// YandexMetrika.jsx
import { useEffect } from "react";

const YM_ID = 105850410;

export default function YandexMetrika() {
    useEffect(() => {
        // уже подключено?
        if ([...document.scripts].some(s => s.src?.includes("mc.yandex.ru/metrika/tag.js"))) return;

        // глобальная функция ym
        (function(m,e,t,r,i,k,a){
            m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            k=e.createElement(t); a=e.getElementsByTagName(t)[0];
            k.async=1; k.src=r; a.parentNode.insertBefore(k,a);
        })(window, document, "script", `https://mc.yandex.ru/metrika/tag.js?id=${YM_ID}`, "ym");

        window.ym?.(YM_ID, "init", {
            ssr: true,
            webvisor: true,
            clickmap: true,
            ecommerce: "dataLayer",
            accurateTrackBounce: true,
            trackLinks: true
        });
    }, []);

    // noscript-пиксель для случаев без JS
    return (
        <noscript>
            <div>
                <img src={`https://mc.yandex.ru/watch/${YM_ID}`}
                     style={{ position: "absolute", left: "-9999px" }} alt="" />
            </div>
        </noscript>
    );
}
